// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorInfoModal_wrapper__3ODSF","content":"ErrorInfoModal_content__xqWi7","buttonStyle":"ErrorInfoModal_buttonStyle__MBC64"};